import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { EmailVerificationResponse } from '../../../core/models/email-verification-response.model';
import { CommonModule } from '@angular/common';
import { ValidationMessageComponent } from '../../../shared/components/validation-message/validation-message.component';
import { EmailVerificationComponent } from '../../../shared/components/email-verification/email-verification.component';
import { ConfirmPasswordDirective } from '../../../shared/directives/confirm-password.directive';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MiddlewareService } from '../../../core/services/middleware.service';
import { ApiResponse } from '../../../core/enums/api-response.enum';
import { apiURL } from '../../../../assets/data/api-url';
import { EncryptionService } from '../../../core/services/encryption.service';
import { ModalType } from '../../../core/enums/modal-type.enum';
import { ModalService } from '../../../core/services/modal.service';
import { globalDatas } from '../../../../assets/data/globals';
import { CommonService } from '../../../core/services/common.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    ValidationMessageComponent,
    EmailVerificationComponent,
    ConfirmPasswordDirective,
    TranslateModule,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  forgotForm!: FormGroup;
  isSubmitted = false;
  showPassword = false;
  showConfrimPassword = false;
  componentName = 'forgotPassword';
  passwordCustomValidation = { pattern: 'VALIDATION.INVALID_PASSWORD_PATTERN' };
  emittedData!: any;
  forgotPasswordDetails: any;
  constructor(
    public router: Router,
    private _fb: FormBuilder,
    private _middlewareService: MiddlewareService,
    private encryptionService: EncryptionService,
    private modalService: ModalService,
    private commonService: CommonService,
    public translate: TranslateService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.forgotPasswordDetails = {
      token: this.route.snapshot.queryParamMap.get('data') || '',
    };
    this.loadForgotForm();
  }


  onVerifyOTP(emittedData: EmailVerificationResponse) {
    if (emittedData?.status) {
      this.emittedData = emittedData;
      this.forgotForm.get('email')?.setValue(emittedData?.email);
      this.forgotForm.get('email')?.disable();
    }
  }

  loadForgotForm() {
    this.forgotForm = this._fb.group({
      password: [
        '',
        [
          Validators.required,
          Validators.pattern(
            globalDatas.PASSWORD_REG_EXP
          ),
        ],
      ],
      confirmPassword: ['', [Validators.required]],
    });
  }

  async onSubmit() {
    this.isSubmitted = true;
    if (this.forgotForm.valid) {
      this.submitForgotPassword();
    }
  }

  async submitForgotPassword() {
    if (this.forgotForm.valid) {
      const encryptedPayload = await this.encryptionService.encryptData({
        password: this.forgotForm.get('confirmPassword')?.value,
        token: this.forgotPasswordDetails?.token
      }
      );
      this._middlewareService
        .callPostMiddleware(`${apiURL.forgotPassword}`, {
          payload: encryptedPayload,
        })
        .subscribe((result: any) => {
          if (result?.code === ApiResponse.OK) {
            this.modalService.commonAlertModal('FORGOT.SUCCESS_MESSAGE', ModalType.SUCCESS);
            this.router.navigate([this.commonService.getRouteStartIndex() + '/sign-in']);
          }
        });
    }
  }
}
